import { Component, OnInit } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { PopupService } from 'app/services/shared/popup.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { EnterOtpPopupComponent } from './enter-otp-popup/enter-otp-popup.component';

@Component({
  selector: 'app-link-carrier-account',
  templateUrl: './link-carrier-account.component.html',
  styleUrls: ['./link-carrier-account.component.css']
})
export class LinkCarrierAccountComponent implements OnInit {

  isLoading: Boolean = false;
  message: string = 'Loading  carrier accounts, please wait...';
  carrierAccounts: any = [];
  userData: any;
  roles: any = [
    { role: 1, desc: "Lead User" },
    { role: 2, desc: "Editor User" },
    { role: 6, desc: "Read User" },
    { role: 11, desc: "Owner" },
    { role: 12, desc: "Consultant" },
    { role: 21, desc: "Main Contact" }
  ];
  user: any = {};
  account;

  constructor(private carrierAccountService: CarrierAccountService, private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router,
    private toaster: ToastrService, private showModal: PopupService) { 
      this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    }

  ngOnInit() {
    this.userData = this.authWebService.userData;
    this.GetAccounts();
  }
  GetAccounts() {
    this.carrierAccountService.GetLinkedCarrierAccounts(this.userData.User.Id).subscribe(result => {
      this.carrierAccounts = result;
    });
  }
  enterOTP(acc) {
   let OtpMessage = document.getElementById('OtpMessage');
	 OtpMessage.innerHTML  ="Enter Your OTP to complete linking to " + acc.carrier_name;
   this.account = acc;
   document.getElementById('secretButton').click();
    // this.dialogService.addDialog(EnterOtpPopupComponent, {
    //   title: "Carrier Accounts: Enter OTP",
    //   message: "Enter Your OTP to complete linking to " + acc.carrier_name,
    //   comment: ``,
    //   confirmButtonText: "Proceed",
    //   cancelButtonText: "Cancel",
    //   account: acc
    // }).subscribe((isConfirmed) => {
    //   if (isConfirmed) {
    //     this.GetAccounts();
    //     this.toaster.success('The account of Carrier ' + acc.carrier_name + ' has been successfully linked to you. You are now their Consultant.');
    //   } else {
    //     this.toaster.warning('Invalid OTP.');
    //   }
    // });
  }
  getRoleDesc(role_ind){
    return this.roles.find(x => x.role == role_ind).desc;
  }

  confirm(otpInput) {
    this.carrierAccountService.EnterCarrierAccountLinkOTP(this.account.carrier_person_id, otpInput.value).subscribe(result => {
      if (result == "success") {
        this.GetAccounts();
        this.toaster.success('The account of Carrier ' + this.account.carrier_name + ' has been successfully linked to you. You are now their Consultant.');
             
        //this.result = true;
        //this.close();
      }
      else {
        this.toaster.warning('Invalid OTP.');
        //this.result = false;
        //this.close();
      }
    });
  }

}
